import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Close from '@material-ui/icons/Close'
import ErrorOutline from '@material-ui/icons/ErrorOutline'
import withStyles from '@material-ui/core/styles/withStyles';
import firebase from '../../Firebase';
import { connect } from 'react-redux'
import AsyncStorage from '@callstack/async-storage';

const styles = theme => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#f2a811',
      borderRadius: '5px',
    }
  },
  main: {
    width: 'auto',
    display: 'block',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: '50%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: '#fff',
    width: 170,
    height: 170,
    borderRadius: 0,
  },
  form: {
    width: '100%',
    marginTop: theme.spacing.unit,
  },
  label: {
    '&$cssFocused': {
      color: '#f2a811',
    },
  },
  input: {
    '&:after': {
      borderBottomColor: '#f2a811',
    },
  },
  checkbox: {
    color: '#f2a811',
    '&$checked': {
      color: '#f2a811',
    },
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    color: '#fff',
    backgroundColor: '#f2a811',
    '&:hover': {
      backgroundColor: '#b1730d',
    },
  },
  loadingColorPrimary: {
    backgroundColor: '#f2a811',
  },
  loadingBarColorPrimary: {
    backgroundColor: '#b1730d',
  },
  snackbarError: {
    backgroundColor: theme.palette.error.dark,
  },
  snackbarErrorMessage: {
    display: 'flex',
    alignItems: 'center',
  },
  errorIcon: {
    fontSize: 20,
  },
});

class Privacy extends React.Component {
  constructor(props){
    super(props)
    this.state={
      config:[{
        privacy:''
      }]
    }
  }

  componentWillMount()
  {
       firebase.firestore().collection("config").get().then(snapshot => {
          this.setState({config:JSON.parse(snapshot.docs[0]._document.data.toString())});
        });

  }

  componentWillUnmount(){
   
  }

  
  render(){
    console.log(this.state.config)
    const { classes } = this.props;
   
    return (
      <main className={classes.main}>
        <CssBaseline />
        <div className={classes.paper}>
            <Avatar src="images/easysuki-logo.png" className={classes.avatar}/>
            <br/>
            <div dangerouslySetInnerHTML={{__html: this.state.config.privacy }} />
            
        </div>
      </main>
    )
  }
}

Privacy.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {state:state}
}

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (userid,user) => dispatch({type: "SET_USER", payload: { userid: userid, user: user }})
  }

}

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(Privacy));
